import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './containers/home/home.component';
import { CB_LOGIN_ROUTES } from './lib/login-controller-routing.module';
import { useHash } from './lib/services/cb-envars';

const routes: Routes = [
  CB_LOGIN_ROUTES,
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
